export default "__VITE_ASSET__ac1dd2c5__"